import { NextSeo } from 'next-seo';
import { FC } from 'react';

import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResource } from '@/lib/datx-jsonapi-react';
import { queryThinProfile } from '@/queries/thin-profiles';

export const SpeakersPageSeo: FC = () => {
  const { id } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { data: profile } = useResource(queryThinProfile(id));

  if (!profile) {
    return null;
  }

  return (
    <NextSeo
      title={`${profile.firstName || ''} ${profile.lastName || ''}`.trim()}
      description={profile.shortBio}
      canonical={`${process.env.NEXT_PUBLIC_BASE_URL}speakers/${profile.linkSlug}`}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_BASE_URL}speakers/${profile.linkSlug}`,
        title: `${profile.firstName || ''} ${profile.lastName || ''}`.trim(),
        description: profile?.shortBio || '',
        images: [
          {
            url: profile.avatar,
            width: 800,
            height: 600,
            alt: `Photo - ${profile.fullName}`,
          },
        ],
      }}
    />
  );
};
